var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"transparent"},attrs:{"id":"login-view"}},[_c('v-main',[_c('router-view')],1),_c('canvas',{attrs:{"id":"bg_canvas"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }